// removed by extract-text-webpack-plugin
module.exports = {"m":"(min-width: 48em)","ixt-blue-50":"#e3f1fc","default-font-family":"Circular, sans-serif","monospace-font-family":"'Roboto Mono', monospace"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Typography.css
// module id = 513
// module chunks = 2